import useDebounce from 'CustomHooks/useDebounce';
import api from 'http';
import useSuperSearchDropdownContext from 'NewComponents/FormComponents/SuperSearchDropdown/useSuperSearchDropdownContext';
import React, { useEffect } from 'react';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import styles from './PatientSuperSearchInput.module.css';
import { FiSearch, FiX } from 'react-icons/fi';
import { CgSpinner } from 'react-icons/cg';

const PatientSuperSearchInput = ({ searchValue, onChange, handleSelectedData, identifier, ...props }) => {
  const { onToggleLoader, onToggleDropDown, onSetData, onSetInputValue, onSetSearchStatus, onSetSelectedRowNumber, state } = useSuperSearchDropdownContext();
  const debouncedSearchTerm = useDebounce(searchValue, 500);

  const { data, loading, searchStatus, selectedRowNumber } = state;
  const onKeyDownPressed = async (event_) => {
    switch (event_.keyCode) {
      case 13: {
        // User pressed the ENTER key
        if (data.length > 0) {
          await handleSelectedData(data[selectedRowNumber], event_);
          // setShowTable(false);
          //setSelectedRowNumber(0)
          onSetSearchStatus(false);
          onSetInputValue('');
          onToggleDropDown(false);
        }

        break;
      }
      case 38: {
        // if user presses the UP
        if (selectedRowNumber > 0) {
          const previousRowNumber = selectedRowNumber - 1;
          onSetSelectedRowNumber(previousRowNumber);
          const selectedRowUP = selectedRowNumber - 1;
          var element = document.querySelector(`#${identifier}_${selectedRowUP}`);
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }

        break;
      }
      case 40: {
        // IF USER PRESSES DOWN KEY
        if (selectedRowNumber < data.length - 1) {
          const previousRowNumber = selectedRowNumber + 1;
          onSetSelectedRowNumber(previousRowNumber);
          const selectedRowDown = selectedRowNumber + 1;
          let element = document.querySelector(`#${identifier}_${selectedRowDown}`);

          element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }

        break;
      }
      case 27: {
        // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
        resetComponent();

        break;
      }
      case 9: {
        // IF USER PRESSES THE TAB BUTTON
        if (data.length > 0) {
          handleSelectedData(data[selectedRowNumber]);
        }

        break;
      }
      default: {
        break;
      }
    }
  };
  // =========================== ON CHANGE HANDLER OF THE INPUT FIELD =============================
  const onHandleChange = async (event_) => {
    let eventValue = event_.target.value.replace(/^\s+/, '');
    onChange(eventValue);
    onSetInputValue(eventValue);
    if (eventValue === '') {
      onSetSearchStatus(false);
      onSetSelectedRowNumber(0);
      onToggleDropDown(false);
    } else {
      onSetSearchStatus(true);
    }
  };
  const resetComponent = () => {
    onChange('');
    handleSelectedData();
    onSetInputValue('');
    onSetSearchStatus(false);
    onSetSelectedRowNumber(0);
    onSetData([]);
    onToggleDropDown(false);
  };
  // Helper function to handle API calls
  const handleApiCall = React.useCallback(
    async (debouncedSearchTerm) => {
      const patientResp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/Patient/PatientSuperSearch/${debouncedSearchTerm}`);

      onSetData(patientResp.data.dataModel.data);
      onToggleDropDown(true);
    },
    [onSetData, onToggleDropDown],
  );
  useEffect(() => {
    if (searchStatus && debouncedSearchTerm.length >= 2) {
      (async () => {
        try {
          onToggleLoader(true);
          await handleApiCall(debouncedSearchTerm);
        } catch (error) {
          ErrorHandlingMessage(error);
        } finally {
          onToggleLoader(false);
        }
      })();
    }
  }, [searchStatus, debouncedSearchTerm, onToggleLoader, handleApiCall]);
  return (
    <>
      <div className={styles.varriant2}>
        <div className='absolute transform -translate-y-1/2 left-2 top-1/2'> <FiSearch size={props.mainSearch ? 16 : 14} className='text-[#8D8D8D]' /></div>
        <input
          onChange={onHandleChange}
          value={searchValue}
          id={`superSearchInputField_${identifier}`}
          type="text"
          autoComplete="off"
          className={
            props.mainSearch
              ? styles.varriant1_input2
              : 'h-9 w-full rounded-[0.25rem] border  py-1.5  px-7 text-xs focus:outline-none  focus:border-primary disabled:bg-gray-100'
          }
          placeholder='Search Patients...'
          onKeyDown={onKeyDownPressed}
          maxLength={20}
        />
        {
          searchValue ? (
            <button type="button" className='absolute bg-[#f8fafb] transform -translate-y-1/2 right-2 top-1/2' onClick={resetComponent}   >
              {loading ? <CgSpinner className='animate-spin' /> : <FiX size={16} className='text-[#8D8D8D] cursor-pointer' />}
            </button>
          ) : null
        }


      </div>
    </>

  );
};

export default PatientSuperSearchInput;
